// Stats Service - Interacts with backend stats API (JSON file storage)
const STATS_API_URL = process.env.REACT_APP_STATS_API_URL || 'https://jeeter-backend.vercel.app/api/stats';

class StatsService {
  constructor() {
    this.cache = {
      visits: null,
      walletScans: null,
      leaderboard: null,
      lastFetch: null
    };
    this.cacheTTL = 5000; // 5 seconds cache
  }

  // Get all stats
  async getAllStats() {
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:16',message:'getAllStats called',data:{apiUrl:STATS_API_URL,cachedVisits:this.cache.visits,cachedScans:this.cache.walletScans},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H4'})}).catch(()=>{});
    // #endregion
    try {
      const response = await fetch(`${STATS_API_URL}?action=all`);
      if (!response.ok) {
        throw new Error(`Stats API error: ${response.status}`);
      }
      const data = await response.json();
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:23',message:'getAllStats data received',data:{success:data.success,visits:data.data?.visits,walletScans:data.data?.walletScans,hasData:!!data.data},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H4'})}).catch(()=>{});
      // #endregion
      if (data.success && data.data) {
        this.cache = {
          visits: data.data.visits || 0,
          walletScans: data.data.walletScans || 0,
          leaderboard: data.data.leaderboard || [],
          lastFetch: Date.now()
        };
        return this.cache;
      }
      return { visits: 0, walletScans: 0, leaderboard: [] };
    } catch (error) {
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:35',message:'getAllStats error',data:{error:error.message,usingCache:true},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H4'})}).catch(()=>{});
      // #endregion
      console.error('Error fetching stats:', error);
      // Return cached data if available, otherwise defaults
      return {
        visits: this.cache.visits || 0,
        walletScans: this.cache.walletScans || 0,
        leaderboard: this.cache.leaderboard || []
      };
    }
  }

  // Increment visit count
  async incrementVisit() {
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:45',message:'incrementVisit called',data:{apiUrl:STATS_API_URL},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H1'})}).catch(()=>{});
    // #endregion
    try {
      const response = await fetch(`${STATS_API_URL}?action=increment_visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:53',message:'incrementVisit response',data:{status:response.status,ok:response.ok},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H1'})}).catch(()=>{});
      // #endregion
      if (!response.ok) {
        throw new Error(`Stats API error: ${response.status}`);
      }
      const data = await response.json();
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:60',message:'incrementVisit data',data:{success:data.success,visits:data.data?.visits,hasData:!!data.data},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H1'})}).catch(()=>{});
      // #endregion
      if (data.success && data.data) {
        this.cache.visits = data.data.visits || 0;
        return this.cache.visits;
      }
      return this.cache.visits || 0;
    } catch (error) {
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:67',message:'incrementVisit error',data:{error:error.message,fallback:true},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H1'})}).catch(()=>{});
      // #endregion
      console.error('Error incrementing visit:', error);
      // Fallback: increment local cache
      this.cache.visits = (this.cache.visits || 0) + 1;
      return this.cache.visits;
    }
  }

  // Increment wallet scan count
  async incrementWalletScan() {
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:71',message:'incrementWalletScan called',data:{apiUrl:STATS_API_URL},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H2'})}).catch(()=>{});
    // #endregion
    try {
      const response = await fetch(`${STATS_API_URL}?action=increment_wallet_scan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:79',message:'incrementWalletScan response',data:{status:response.status,ok:response.ok},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H2'})}).catch(()=>{});
      // #endregion
      if (!response.ok) {
        throw new Error(`Stats API error: ${response.status}`);
      }
      const data = await response.json();
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:86',message:'incrementWalletScan data',data:{success:data.success,walletScans:data.data?.walletScans,hasData:!!data.data},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H2'})}).catch(()=>{});
      // #endregion
      if (data.success && data.data) {
        this.cache.walletScans = data.data.walletScans || 0;
        return this.cache.walletScans;
      }
      return this.cache.walletScans || 0;
    } catch (error) {
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/a26cdc5f-d73f-4028-8b75-616d869592b7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'statsService.js:93',message:'incrementWalletScan error',data:{error:error.message,fallback:true},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'H2'})}).catch(()=>{});
      // #endregion
      console.error('Error incrementing wallet scan:', error);
      // Fallback: increment local cache
      this.cache.walletScans = (this.cache.walletScans || 0) + 1;
      return this.cache.walletScans;
    }
  }

  // Update leaderboard
  async updateLeaderboard(leaderboard) {
    try {
      const response = await fetch(`${STATS_API_URL}?action=update_leaderboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ leaderboard })
      });
      if (!response.ok) {
        throw new Error(`Stats API error: ${response.status}`);
      }
      const data = await response.json();
      if (data.success && data.data) {
        this.cache.leaderboard = data.data.leaderboard || [];
        return this.cache.leaderboard;
      }
      return this.cache.leaderboard || [];
    } catch (error) {
      console.error('Error updating leaderboard:', error);
      // Fallback: update local cache
      this.cache.leaderboard = leaderboard;
      return this.cache.leaderboard;
    }
  }

  // Get visits count
  async getVisits() {
    if (this.cache.visits !== null && this.cache.lastFetch && (Date.now() - this.cache.lastFetch) < this.cacheTTL) {
      return this.cache.visits;
    }
    const stats = await this.getAllStats();
    return stats.visits || 0;
  }

  // Get wallet scans count
  async getWalletScans() {
    if (this.cache.walletScans !== null && this.cache.lastFetch && (Date.now() - this.cache.lastFetch) < this.cacheTTL) {
      return this.cache.walletScans;
    }
    const stats = await this.getAllStats();
    return stats.walletScans || 0;
  }

  // Get leaderboard
  async getLeaderboard() {
    if (this.cache.leaderboard !== null && this.cache.lastFetch && (Date.now() - this.cache.lastFetch) < this.cacheTTL) {
      return this.cache.leaderboard;
    }
    const stats = await this.getAllStats();
    return stats.leaderboard || [];
  }
}

const statsService = new StatsService();
export default statsService;

